import { useAuthAtom } from "store/auth";

export const useAuth = () => {
  const [auth] = useAuthAtom();

  return { token: auth.accessToken };
};
